import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-description-length',
  templateUrl: './description-length.component.html',
  styleUrls: ['./description-length.component.css']
})
export class DescriptionLengthComponent implements OnInit {
  
  @Input()
  current;

  @Input()
  max;

  constructor() { }

  ngOnInit() {
  }

}
